import { Calendar } from "lucide-react";
import { Accordion, CeremonyFormFields } from "@/components/customer/events";
import { useTranslation } from "@/hooks/useTranslation";

interface PartyCeremonyAccordionProps {
  enabled: boolean;
  date: string;
  time: string;
  locationName: string;
  address: string;
  onDateChange: (value: string) => void;
  onTimeChange: (value: string) => void;
  onLocationNameChange: (value: string) => void;
  onAddressChange: (value: string) => void;
}

export function PartyCeremonyAccordion({
  enabled,
  date,
  time,
  locationName,
  address,
  onDateChange,
  onTimeChange,
  onLocationNameChange,
  onAddressChange,
}: PartyCeremonyAccordionProps) {
  const { t } = useTranslation();
  if (!enabled) {
    return null;
  }

  return (
    <Accordion
      title={t("events.form.party")}
      icon={<Calendar className="h-6 w-6 text-pink-600 dark:text-pink-400" />}
      defaultOpen={false}
    >
      <CeremonyFormFields
        date={date}
        time={time}
        locationName={locationName}
        address={address}
        onDateChange={onDateChange}
        onTimeChange={onTimeChange}
        onLocationNameChange={onLocationNameChange}
        onAddressChange={onAddressChange}
      />
    </Accordion>
  );
}

